import { useEffect, useState } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';

const globalReadyTracking: { isReady: boolean } = { isReady: false };

export function useFeatureFlagsReady(): boolean {
  const client = useLDClient();
  const [ready, setReady] = useState(globalReadyTracking.isReady);

  useEffect(() => {
    if (client && !globalReadyTracking.isReady) {
      client?.waitUntilReady().then(() => {
        globalReadyTracking.isReady = true;
        setReady(true);
      });
    }
  }, [client]);

  return ready;
}
